import React from 'react';

export const printWithNBSP = (processedString: string) => {
	const stringParts = processedString.split('&nbsp;');
	if (stringParts.length === 1) {
		return stringParts;
	}

	let result: (string | React.ReactElement)[] = [];

	stringParts.forEach((part, index) => {
		result.push(part);

		if (index !== stringParts.length - 1) {
			result.push(<span key={`${part}__${index}`}>&nbsp;</span>);
		}
	});

	return result;
};

export const printWithoutNBSP = (processedString: string) => processedString.replace('&nbsp;', ' ');
